import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mx-auto mt-3 w-8/12"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-lg font-bold" }, " Empty chat history! ", -1)
const _hoisted_4 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_5 = {
  key: 1,
  class: "flex w-full items-center justify-between rounded-lg bg-[#EEEEEE] shadow-sm"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "my-1 text-xs text-gray-500"
}
const _hoisted_8 = { class: "text-md truncate text-left font-medium" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "my-1 flex items-center justify-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "loading loading-spinner loading-md" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

import {
  ArrowTopRightOnSquareIcon,
  EllipsisVerticalIcon,
  PencilIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {
  onMounted,
  ref,
  watch,
} from 'vue';
import EditTitleForm from '@/components/ChatInterface/ChatHistory/EditTitleForm.vue';
import InfiniteScroll from '@/components/Helper/InfiniteScroll.vue';
import CustomLoader1 from '@/components/Helper/Loader/CustomLoader1.vue';
import {
  type ConversationHistoryService,
  getConversationHistoryService,
} from '@/services/ConversationHistoryService';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatHistoryList',
  emits: ["conversation:id"],
  setup(__props, { emit: __emit }) {

dayjs.extend(localizedFormat);

const emits = __emit;

const conversationHistoryStore = useStore.conversationHistory;
const utilStore = useStore.util;

let conversationHistoryService: ConversationHistoryService;
const historyInitialLoadAt: string = new Date().toISOString();

const shouldOpenUpwards = ref(false);

const editConversationId = ref('');
const openedMenuId = ref<null | string>(null);

const isTitleUpdating = ref(false);

watch(
  [(): boolean => conversationHistoryStore.showHistoryList,
    (): boolean => utilStore.isChatOpen],
  ([newShowHistoryList, newIsChatOpen]) => {
    if (newShowHistoryList || newIsChatOpen) {
      editConversationId.value = '';
    }
  },
);

function checkMenuPosition(event: MouseEvent): void {
  const menuHeight = 200;
  const distanceFromBottom = window.innerHeight - event.clientY;
  shouldOpenUpwards.value = distanceFromBottom < menuHeight;
}

function onSingleHistoryMenuClick(conversationId: string, event: MouseEvent): void {
  checkMenuPosition(event);

  if (!isEditing(conversationId)) {
    toggleMenu(conversationId);
  }
}

function isMenuOpen(conversationId: string): boolean {
  return openedMenuId.value === conversationId;
}

function isEditing(conversationId: string): boolean {
  return editConversationId.value === conversationId;
}

function onEdit(id: string): void {
  editConversationId.value = id;
  openedMenuId.value = null; // Close the dropdown when clicking Edit
}

function onEditCancel(): void {
  editConversationId.value = '';
}

async function onEditConfirm(
  conversationId: string,
  newTitle: string,
  prevTitle: string,
): Promise<void> {
  const trimmedTitle = newTitle.trim();

  // Check if the title is empty or unchanged
  if (trimmedTitle && trimmedTitle !== prevTitle) {
    isTitleUpdating.value = true;
    await conversationHistoryService.updateTitle(conversationId, trimmedTitle);
  }

  editConversationId.value = '';
  openedMenuId.value = null; // Close the dropdown after confirming edit

  isTitleUpdating.value = false;
}

function toggleMenu(conversationId: string): void {
  if (openedMenuId.value === conversationId) {
    openedMenuId.value = null;
  } else {
    openedMenuId.value = conversationId;
  }
}

function onExportConversation(conversationId: string): void {
  conversationHistoryService.exportConversation(conversationId);
  openedMenuId.value = null;
}

async function loadConversationHistory(): Promise<void> {
  await conversationHistoryService.loadConversationHistory(historyInitialLoadAt);
}

onMounted(() => {
  conversationHistoryService = getConversationHistoryService();
  loadConversationHistory();
});

return (_ctx: any,_cache: any) => {
  return (!_unref(conversationHistoryStore).conversationList.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: require('@/assets/empty.png'),
          alt: "empty chat history"
        }, null, 8, _hoisted_2),
        _hoisted_3
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(InfiniteScroll, { onLoad: loadConversationHistory }, {
          top: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversationHistoryStore).conversationList, (conversation) => {
              return (_openBlock(), _createElementBlock("div", {
                key: conversation._id,
                class: "w-full px-3 py-1"
              }, [
                (editConversationId.value === conversation._id)
                  ? (_openBlock(), _createBlock(EditTitleForm, {
                      key: 0,
                      createdAt: conversation.createdAt,
                      text: conversation.title,
                      isLoading: isTitleUpdating.value,
                      onConfirm: (value) => onEditConfirm(conversation._id, value, conversation.title),
                      onCancel: onEditCancel
                    }, null, 8, ["createdAt", "text", "isLoading", "onConfirm"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "w-full overflow-hidden px-4 py-2 text-start hover:rounded-lg hover:bg-[#d8d8d8]",
                        onClick: ($event: any) => (emits('conversation:id', conversation._id))
                      }, [
                        (conversation.createdAt)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(dayjs)(conversation.createdAt).format('lll')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("h1", _hoisted_8, _toDisplayString(conversation.title), 1)
                      ], 8, _hoisted_6),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["mx-2 flex items-center justify-center p-3 hover:rounded-full hover:bg-[#c5c5c5]", { hidden: isEditing(conversation._id) }]),
                        onClick: ($event: any) => (onSingleHistoryMenuClick(conversation._id, $event))
                      }, [
                        (!isMenuOpen(conversation._id) && !isEditing(conversation._id))
                          ? (_openBlock(), _createBlock(_unref(EllipsisVerticalIcon), {
                              key: 0,
                              class: "size-5"
                            }))
                          : _createCommentVNode("", true),
                        (isMenuOpen(conversation._id) && !isEditing(conversation._id))
                          ? (_openBlock(), _createBlock(_unref(XMarkIcon), {
                              key: 1,
                              class: "size-5 text-gray-500"
                            }))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_9)
                    ])),
                _createElementVNode("div", _hoisted_10, [
                  (isMenuOpen(conversation._id))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "fixed inset-0",
                        onClick: ($event: any) => (toggleMenu(conversation._id))
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  (isMenuOpen(conversation._id))
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: 1,
                        class: _normalizeClass(["menu menu-lg absolute right-0 z-10 mt-1 w-46 rounded-md bg-base-100 shadow-lg", { 'bottom-full mb-2': shouldOpenUpwards.value }])
                      }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "flex w-full items-center justify-start gap-2 p-2 text-left text-sm",
                            onClick: ($event: any) => (onEdit(conversation._id))
                          }, [
                            _createVNode(_unref(PencilIcon), { class: "size-4" }),
                            _createTextVNode(" Edit title ")
                          ], 8, _hoisted_12)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "flex w-full items-center justify-start gap-2 p-2 text-left text-sm",
                            onClick: ($event: any) => (onExportConversation(conversation._id))
                          }, [
                            _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "size-4" }),
                            _createTextVNode(" Export conversation ")
                          ], 8, _hoisted_13)
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        (_unref(conversationHistoryStore).isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true)
      ]))
}
}

})